import * as actions from './actions'

const getRoot = state => state.__KNOWLEDGEBASE.settings

export const getSettings = state => getRoot(state).settings

export const getChanged = state => getRoot(state).changed

export const getHostName = state => getSettings(state).cnameDomain
export const getCanonicalDomain = state => getSettings(state).canonicalDomain
export const getGoogleAnalyticsCode = state => getSettings(state).googleAnalyticsCode

export const getIsKBIndexed = state => getSettings(state).isKBIndexed

export const getColor = state => getSettings(state).mainColor

export const getBotConfigEnabled = state => getRoot(state).botConfig.enabled
export const getBotDataSource = state => getRoot(state).botConfig.botDatasource

export const getSyncedKnowledgebaseList = state => getRoot(state).syncedKnowledgebaseList

export const getCustomLinks = state => getSettings(state).customLinks
export const getCustomLink = state => getSettings(state).selectedCustomLink

const getUpdateSettingsStatus = state => getRoot(state).updateSettingsStatus
export const getUpdateSettingsLoading = state => getUpdateSettingsStatus(state) === actions.updateSettingsPending.toString()
